import clientLogger from '../logging/client.logger';

const ENGINE_OFF_KEY = 'facilita.upload.engineOffUntil';
const ENGINE_OFF_MINUTES = 10;
const MS_PER_MINUTE = 60000;
const LOG_CONTEXT = 'upload:engine-state';

const attempt = (work, fallback) => {
    try {
        return work();
    } catch (error) {
        clientLogger.logClientError({ context: LOG_CONTEXT, message: 'storage-unavailable', payload: { name: (error && error.name) || null } });
        return fallback;
    }
};

const browserStorage = () => attempt(() => window.sessionStorage, null);

export const createEngineState = ({ storage = browserStorage(), now = () => Date.now(), ttlMs = ENGINE_OFF_MINUTES * MS_PER_MINUTE } = {}) => ({
    markOff: () => attempt(() => storage && storage.setItem(ENGINE_OFF_KEY, String(now() + ttlMs)), undefined),
    isKnownOff: () => attempt(() => Boolean(storage) && Number(storage.getItem(ENGINE_OFF_KEY)) > now(), false),
});

export const engineState = createEngineState();
